import type { ReactElement } from "react";
import { forwardRef, useMemo } from "react";
import { useValidation } from "@/shared/forms";
import type { LimitedValuesField as LimitedValuesFieldProps } from "./types";

export const LimitedValuesField = forwardRef<HTMLSelectElement, LimitedValuesFieldProps>(function LimitedValuesField(
    { ariaLabel, value, onChange, required = false, limitedValues, id, ...rest },
    ref,
) {
    useValidation(id, {
        errorLocation: "callout",
        rules: { required },
    });

    const elements = useMemo(() => {
        const result: ReactElement[] = [];
        let currentOptgroup: ReactElement[] = [];
        let optgroupLabel = "";

        limitedValues.forEach((limitedValue) => {
            if (limitedValue.value === "#") {
                if (currentOptgroup.length > 0) {
                    result.push(
                        <optgroup key={optgroupLabel} label={optgroupLabel}>
                            {currentOptgroup}
                        </optgroup>,
                    );
                }
                currentOptgroup = [];
                optgroupLabel = limitedValue.label;
            } else {
                const option = (
                    <option key={limitedValue.value} value={limitedValue.value}>
                        {limitedValue.label}
                    </option>
                );

                if (optgroupLabel) {
                    currentOptgroup.push(option);
                } else {
                    result.push(option);
                }
            }
        });

        if (currentOptgroup.length > 0) {
            result.push(
                <optgroup key={optgroupLabel} label={optgroupLabel}>
                    {currentOptgroup}
                </optgroup>,
            );
        }

        return result;
    }, [limitedValues]);

    return (
        <select
            id={id}
            value={value}
            onChange={onChange}
            required={required}
            aria-label={ariaLabel}
            ref={ref}
            {...rest}
        >
            {elements}
        </select>
    );
});
